import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import { Col, Row } from 'react-flexbox-grid';
import { Checkbox, DatePicker, Radio } from 'antd';
import Moment from 'moment';
import PreEErrors from './PreExceptionError';
import Spinner from '../../../components/Spinner';
import '../PreEExceptionDialog/styles.css';
import { CalendarOutlined, CloseOutlined } from '@ant-design/icons';
import { isAdministrator } from "../../../utils/UserInfo";
import IPSLocationHeader from '../PreEFormFields/IPSLocationHeader';
import IPSLocations from '../PreEFormFields/IPSLocations';
import IPSLocationAssetCollapse from '../PreEFormFields/IPSLocations/IPSLocationAssetCollapse';

const errorStyle = {
    color: 'red'
};

const closedCheckBoxStyle = {
    textAlign: 'left',
    backgroundColor: '#d3d3d3'
};

class PreEExceptionDialogBody extends Component {

    scrollStyle = {
        maxHeight: '65vh',
        overflowY: 'auto',
        padding: '20px'
    };

    narrative = {
        instruction:
            "If any of the required tasks on the Pre‐Energization section cannot be completed at the time " +
            "of energization submit this Exception Form to be approved before switching may proceed. "
    };

    protectionRadioButtonCaption = {
        title: "Is this Exception related to the Protection System?*"
    };
    ddcRadioButtonCaption = {
        title: "Is this Exception on DDC managed equipment?*"
    };

    exceptionAreaCaption = {
        title: "Situation Requiring Exception*"
    };

    timelineAreaCaption = {
        title: "Timeline for Remaining Work*"
    };

    approvalResponseDateCaption = {
        title: "Approvals Response Needed By"
    };

    primaryContactCaption = {
        title: "Primary Contact"
    }

    expectedResolutionDateCaption = {
        title: "Expected Resolution Date"

    }
    closedCaption = {
        title: "When the situation causing this Exception has been resolved, provide an update to the TDC Coordinator and check here to Close the Exception."
    };
    editVisibleProps = this.props.editVisibleProps


    render() {
        return (
            <Form id={'preE--exception--form'} style={this.scrollStyle}  >
                <PreEErrors error={this.props.error} />
                {(this.props.statusText === "Approved" || this.props.statusText === 'Denied' || this.props.statusText === 'Cancelled') &&
                    <Form.Group as={Row} style={closedCheckBoxStyle}>
                        <Form.Label className="pre-form-label col-xs-10 col-md-9 col-sm-7" style={{ textAlign: 'left' }}><b>{this.closedCaption.title}</b></Form.Label>
                        <Checkbox
                            checked={this.props.closedCheckBoxText}
                            onChange={this.props.onChangeClosedCheckBox}
                            disabled={(this.props.viewOnly)
                                || ((this.props.isCreatorAdminIntCont || this.props.isExternalContributor) && this.props.editVisibleProps)
                                || ((!this.props.isCreatorAdminIntCont) && (!this.props.isExternalContributor))}
                        >Closed</Checkbox>
                    </Form.Group>
                }
                <br />
                <div><strong>{this.narrative.instruction}</strong></div>
                <br />
                <Form.Group as={Row}>
                    <Form.Label className="pre-form-label col-xs-8 col-md-6 col-lg-4" style={{ textAlign: 'left' }}><b>Exception Title:*</b></Form.Label>
                    <div className="col-xs-10 col-md-8 col-sm-6">
                        <Form.Control autoComplete="off" type="text" value={this.props.titleText} onChange={this.props.onChangeTitleTextChg} id="ExceptionTitle"
                            maxLength="100"
                            disabled={(
                                (this.props.viewOnly)
                                || ((this.props.isCreatorAdminIntCont || this.props.isExternalContributor) && this.props.editVisibleProps)
                                || ((this.props.isCreatorAdminIntCont || this.props.isExternalContributor) && (this.props.statusText === 'Approved' || this.props.statusText === "Denied" || this.props.statusText === 'Cancelled' || this.props.statusText === 'Waiting on Response(s)'))
                                || ((!this.props.isCreatorAdminIntCont) && (!this.props.isExternalContributor))
                            )
                                && (!(isAdministrator() && this.props.statusText === 'Approved' && !this.props.editVisibleProps))}
                        />

                    </div>
                </Form.Group>
                <Form.Group as={Row} style={{ textAlign: 'left' }}>
                    <Col className="col-xs-12 col-md-8 col-lg-6 primary-contact-label"><b>{this.primaryContactCaption.title}:*</b></Col>
                    <div className="col-xs-12 col-md-6 col-lg-6">
                        <Form.Control as="select" id="drop-down-primary-contact" value={this.props.primaryContactText}
                            onChange={this.props.onChangePrimaryContact}
                            disabled={(this.props.viewOnly)
                                || ((this.props.isCreatorAdminIntCont || this.props.isExternalContributor) && this.props.editVisibleProps)
                                || ((!this.props.isCreatorAdminIntCont) && (!this.props.isExternalContributor))}>
                            <option
                                id="teamType"
                                key=""
                                value=""
                            >Choose Primary Contact</option>
                            {this.props.teamMembers && this.props.teamMembers.map((team, index) => (
                                <option
                                    id="teamType"
                                    key={index}
                                    value={team.userId}
                                >   {team.firstName} {team.lastName}
                                </option>
                            ))}
                        </Form.Control></div>
                </Form.Group>

                <Form.Group as={Row} style={{ textAlign: 'left' }}>
                    <Col className="col-xs-12 col-md-8 col-lg-6"><b>Approval Status:</b></Col>
                    <Col className="col-xs-8 col-md-6 col-lg-4" disabled={(this.props.viewOnly)
                        || ((this.props.isCreatorAdminIntCont || this.props.isExternalContributor) && this.props.editVisibleProps)
                        || ((!this.props.isCreatorAdminIntCont) && (!this.props.isExternalContributor))
                    }>{this.props.statusText}</Col>
                </Form.Group>


                <Form.Group as={Row} style={{ textAlign: 'left' }}>
                    <Form.Label className="pre-form-label col-xs-12 col-md-8 col-lg-6" style={{ textAlign: 'left', marginTop: '10px' }}><b>{this.approvalResponseDateCaption.title}:*</b></Form.Label>
                    <DatePicker
                        className="col-xs-12 col-md-6 col-lg-5"
                        style={{ marginTop: '10px' }}
                        format={'MMMM DD, YYYY'}
                        suffixIcon={<CalendarOutlined />}
                        id="ApprovalResponseDate"
                        size={"default"}
                        placeholder="Select Date"
                        onChange={this.props.onChangeApprovalResponseDate}
                        value={this.props.approvalResponseDateText ? Moment(this.props.approvalResponseDateText) : this.props.approvalResponseDateText}
                        disabled={(
                            (this.props.viewOnly)
                            || ((this.props.isCreatorAdminIntCont || this.props.isExternalContributor) && this.props.editVisibleProps)
                            || ((this.props.isCreatorAdminIntCont || this.props.isExternalContributor) && (this.props.statusText === 'Approved' || this.props.statusText === "Denied" || this.props.statusText === 'Cancelled' || this.props.statusText === 'Waiting on Response(s)'))
                            || ((!this.props.isCreatorAdminIntCont) && (!this.props.isExternalContributor))
                        )}
                    />
                </Form.Group>
                <Form.Group as={Row} style={{ textAlign: 'left' }}>
                    <Form.Label className="col-xs-10 col-md-9 col-sm-8 pre-form-label" style={{ textAlign: 'left' }}><b>{this.protectionRadioButtonCaption.title}</b></Form.Label>
                    <div className="col-xs-6 col-md-4 col-lg-2" style={{ textAlign: 'left' }}>
                        <Radio.Group
                            id={'protection-system'}
                            style={{ display: 'inline-flex' }}
                            options={[{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }]}
                            onChange={this.props.onChangeProtectionRadioButtonChange}

                            value={this.props.protectionSystemText === "Y" ? 1 : (this.props.protectionSystemText === "N" ? 0 : this.props.protectionSystemText)}
                            disabled={(this.props.viewOnly)
                                || ((this.props.isCreatorAdminIntCont || this.props.isExternalContributor) && this.props.editVisibleProps)
                                || ((this.props.isCreatorAdminIntCont || this.props.isExternalContributor) && (this.props.statusText === 'Approved' || this.props.statusText === "Denied" || this.props.statusText === 'Cancelled' || this.props.statusText === 'Waiting on Response(s)'))
                                || ((!this.props.isCreatorAdminIntCont) && (!this.props.isExternalContributor))}
                        />
                    </div>
                </Form.Group>
                <Form.Group as={Row} style={{ textAlign: 'left' }}>
                    <Form.Label className="pre-form-label col-xs-10 col-md-9 col-sm-8" style={{ textAlign: 'left' }}><b>{this.ddcRadioButtonCaption.title}</b></Form.Label>
                    <div className="col-xs-6 col-md-4 col-lg-2" style={{ textAlign: 'left' }}>
                        <Radio.Group
                            id={'ddc-system-exc'}
                            style={{ display: 'inline-flex' }}
                            options={[{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }]}
                            onChange={this.props.onChangeDDCRadioButtonChange}
                            value={this.props.ddcSystemText === "Y" ? 1 : (this.props.ddcSystemText === "N" ? 0 : this.props.ddcSystemText)}
                            disabled={(this.props.viewOnly)
                                || ((this.props.isCreatorAdminIntCont || this.props.isExternalContributor) && this.props.editVisibleProps)
                                || ((this.props.isCreatorAdminIntCont || this.props.isExternalContributor) && (this.props.statusText === 'Approved' || this.props.statusText === "Denied" || this.props.statusText === 'Cancelled' || this.props.statusText === 'Waiting on Response(s)'))
                                || ((!this.props.isCreatorAdminIntCont) && (!this.props.isExternalContributor))}
                        />
                    </div>
                </Form.Group>
                <label>
                    <h4>{this.exceptionAreaCaption.title}</h4>
                    <div className="col-xs-12 col-md-12 col-md-4 col-sm-6 col-xs-4 col-xs-2">
                        <Form.Control as="textarea" id="situationRequired" rows="5" value={this.props.situationText} maxLength="2400" onChange={this.props.onChangeSituationTextChg}
                            disabled={(
                                (this.props.viewOnly)
                                || ((this.props.isCreatorAdminIntCont || this.props.isExternalContributor) && this.props.editVisibleProps)
                                || ((this.props.isCreatorAdminIntCont || this.props.isExternalContributor) && (this.props.statusText === 'Approved' || this.props.statusText === "Denied" || this.props.statusText === 'Cancelled' || this.props.statusText === 'Waiting on Response(s)'))
                                || ((!this.props.isCreatorAdminIntCont) && (!this.props.isExternalContributor))
                            )
                                && (!(isAdministrator() && this.props.statusText === 'Approved' && !this.props.editVisibleProps))}
                        />
                    </div>
                </label>
                <label>
                    <h4>{this.timelineAreaCaption.title}</h4>
                    <div className="col-xs-12 col-md-12 col-md-4 col-sm-6 col-xs-4 col-xs-2">
                        <Form.Control as="textarea" id="timelineRequired" rows="5" value={this.props.timelineText} maxLength="2400" onChange={this.props.onChangeTimeLineTextChg}
                            disabled={(this.props.viewOnly)
                                || ((this.props.isCreatorAdminIntCont || this.props.isExternalContributor) && this.props.editVisibleProps)
                                || ((this.props.isCreatorAdminIntCont || this.props.isExternalContributor) && (this.props.statusText === "Denied" || this.props.statusText === 'Cancelled' || this.props.statusText === 'Waiting on Response(s)'))
                                || ((!this.props.isCreatorAdminIntCont) && (!this.props.isExternalContributor))} /></div>
                </label>
                <Form.Group as={Row} style={{ textAlign: 'left' }}>
                    <Form.Label className="pre-form-label col-xs-12 col-md-8 col-lg-6 expected-resolution-date-label" style={{ textAlign: 'left', marginTop: '10px' }}><b>{this.expectedResolutionDateCaption.title}:*</b></Form.Label>
                    <DatePicker
                        className="col-xs-12 col-md-6 col-lg-5"
                        style={{ marginTop: '10px' }}
                        format={'MMMM DD, YYYY'}
                        suffixIcon={<CalendarOutlined />}
                        id="ResolutionDate"
                        size={"default"}
                        placeholder="Select Date"
                        onChange={this.props.onChangeResolutionDate}
                        value={this.props.resolutionDateText ? Moment(this.props.resolutionDateText) : this.props.resolutionDateText}
                        disabled={(this.props.viewOnly)
                            || ((this.props.isCreatorAdminIntCont || this.props.isExternalContributor) && this.props.editVisibleProps)
                            || ((this.props.isCreatorAdminIntCont || this.props.isExternalContributor) && (this.props.statusText === "Denied" || this.props.statusText === 'Cancelled' || this.props.statusText === 'Waiting on Response(s)'))
                            || ((!this.props.isCreatorAdminIntCont) && (!this.props.isExternalContributor))}
                    />
                </Form.Group>
                <Form.Group as={Row} >
                    <Form.Label className="col-xs-12 col-md-12"><strong style={{float: 'left'}}> Project IPS Locations:*</strong></Form.Label>
                </Form.Group>
                <IPSLocationAssetCollapse
                    preEFormMappings={(this.props.editVisibleProps && this.props.preFormExceptionMappings) ? this.props.preFormExceptionMappings : this.props.preFormMappings}
                    {...this.props} />

                <div style={{ marginTop: '24px' }}>
                    <div id="file-class">
                        < input
                            type="file"
                            className="file-input"
                            id="uploadPreExceptionFiles"
                            name="upload"
                            accept=".mp4, .mov, .pdf, .xlsx, .csv, .png, .jpg, .img, .docx, .pptx"
                            onChange={this.props.handleselectedFile}
                            disabled={(this.props.viewOnly)
                                || ((this.props.isCreatorAdminIntCont || this.props.isExternalContributor) && this.props.editVisibleProps)
                                || ((this.props.isCreatorAdminIntCont || this.props.isExternalContributor) && (this.props.statusText === "Denied" || this.props.statusText === 'Cancelled' || this.props.statusText === 'Waiting on Response(s)'))
                                || ((!this.props.isCreatorAdminIntCont) && (!this.props.isExternalContributor))}
                            multiple>
                        </input>
                        {this.props.preEAttachments ? this.props.preEAttachments.map(file => {
                            return (
                                <div id={file.fileName}>
                                    <a href={file.fileName} download id="download" name="fileName" id="download-file"
                                        onClick={(event) => this.props.handleFile(file, event)}>
                                        {file.fileName}
                                    </a>
                                    <span
                                        className="input-group-clear bg-light border-0"
                                        onClick={(event) => this.props.deleteSelectedFile(file.fileName, event)}
                                        style={{ display: !this.props.editVisibleProps || this.props.viewOnly ? ((this.props.isCreatorAdminIntCont || this.props.isExternalContributor) && (this.props.statusText === "Denied" || this.props.statusText === 'Cancelled' || this.props.statusText === 'Waiting on Response(s)')) ? 'none' : 'inline-block' : 'none' }}
                                    >
                                        <CloseOutlined />
                                    </span>
                                </div>

                            );
                        }) : ""
                        }
                        {this.props.fileCount && this.props.fileCount > 5 ?
                            <div className="error-file" style={errorStyle}> {this.props.noOfFilesError}</div> : ""}
                        {!this.props.filesizeOk ?
                            <div className="error-file" style={errorStyle}> {this.props.fileSize}</div> : ""}
                    </div>
                </div>
                <Spinner />
            </Form>
        )
    }
}

export default PreEExceptionDialogBody;
